import { Box, LinearProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";

export default function TemporizadorPix({
    expiracao = 300,
    onExpired = () => { }
}: TemporizadorPixProps) {
    const [progress, setProgress] = useState(100);
    const [timeLeft, setTimeLeft] = useState(expiracao);
    const [isExpired, setIsExpired] = useState(false);

    useEffect(() => {
        if (isExpired || !expiracao) return;

        const totalDuration = expiracao * 1000;
        const interval = 1000;
        const decrement = (100 / (totalDuration / interval));

        let savedTime = localStorage.getItem('pixStartTime');
        const now = Date.now();

        if (!savedTime) {
            localStorage.setItem('pixStartTime', now.toString());
            savedTime = now.toString();
        }

        const elapsed = Math.floor((now - parseInt(savedTime)) / 1000);

        if (elapsed >= expiracao) {
            setIsExpired(true);
            onExpired();
            localStorage.removeItem('pixStartTime');
            return;
        }

        const remainingTime = expiracao - elapsed;
        setTimeLeft(remainingTime);
        setProgress(100 - (elapsed / expiracao) * 100);

        const timer = setInterval(() => {
            setTimeLeft(prevTime => {
                if (prevTime <= 1) {
                    clearInterval(timer);
                    setIsExpired(true);
                    onExpired();
                    localStorage.removeItem('pixStartTime');
                    return 0;
                }
                return prevTime - 1;
            });

            setProgress(oldProgress => {
                const newProgress = oldProgress - decrement;
                return Math.max(newProgress, 0);
            });
        }, interval);

        return () => {
            clearInterval(timer);
        };
    }, [expiracao, isExpired, onExpired]);

    if (isExpired) {
        return (
            <Box>
                <Typography variant='subtitle2'>Tempo esgotado!</Typography>
                <Typography variant='h6' fontWeight={'bold'} color="error">00:00</Typography>
                <LinearProgress variant="determinate" value={0} />
            </Box>
        );
    }

    return (
        <Box>
            <Typography variant='subtitle2'>O tempo para pagar acaba em:</Typography>
            <Typography variant='h6' fontWeight={'bold'}>
                {Math.floor(timeLeft / 60)}:{('0' + (timeLeft % 60)).slice(-2)}
            </Typography>
            <LinearProgress variant="determinate" value={progress} />
        </Box>
    );
}

interface TemporizadorPixProps {
    expiracao: number;
    onExpired?: () => void;
}